import React, { useCallback } from 'react';

import { ConditionValueView } from '../ConditionValueView/ConditionValueView';
import { IValue } from '../../../../../../Types/UrvalTypes';
import {
  CondOperatorType,
  IClientAttributeModel,
} from '../../../../../../Types/ClientModelTypes';

interface IProps {
  /** värde inklusive ev. till-värde för intervall */
  value: IValue;
  /** operatorn ska inte visas av den här komponenten, men kan påverka hur värdena visas */
  operator: CondOperatorType;
  /** index för värdet, skickas tillbaka i setValue och setToValue. Bara för att slippa skapa en callback per värde */
  idx: number;
  setValue: (idx: number, newValue: string | number | null) => void;
  setToValue: (idx: number, newToValue: string | number | null) => void;
  attribute: IClientAttributeModel;
  disabled?: boolean;
}

const EnhancedConditionValueView: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { setValue, setToValue, ...restProps } = props;
  const newSetValue = useCallback(
    (newValue: string | number | null) => {
      setValue(props.idx, newValue);
    },
    [props.idx, setValue]
  );
  const newSetToValue = useCallback(
    (newValue: string | number | null) => {
      setToValue(props.idx, newValue);
    },
    [props.idx, setToValue]
  );
  return (
    <ConditionValueView
      setValue={newSetValue}
      setToValue={newSetToValue}
      {...restProps}
    />
  );
};

/**
Visar en rad med från och ev. till värde för en condition
*/
const ConditionValue = (props: IProps) => (
  <EnhancedConditionValueView {...props} />
);

export default ConditionValue;
